import { render, staticRenderFns } from "./CountriesOverview.vue?vue&type=template&id=19875a2d&scoped=true"
import script from "./CountriesOverview.vue?vue&type=script&lang=js"
export * from "./CountriesOverview.vue?vue&type=script&lang=js"
import style0 from "./CountriesOverview.vue?vue&type=style&index=0&id=19875a2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19875a2d",
  null
  
)

export default component.exports